import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
   page: {
       width: "100%",
       justifyContent: 'flex-start',
       flexDirection: 'column',
       alignItems: 'flex-start'
   },
    linkText: {
        color: '#007bff',
        fontWeight: '500',
        fontFamily: 'Montserrat'
    },
    text: {
        fontSize: 14,
        color: '#000006',
        fontWeight: '500',
        fontFamily: 'Montserrat',
        marginBottom: 10,
        marginLeft: 5,
    },
});